import { route } from "typesafe-react-router";

export const paymentRoutes = {
    payPalPayflowIFrame: route("payment", "payflow-return"),
    payPalPayflowFields: route("payment", "payflow"),
    index: route("payment"),
};
